export default "__VITE_ASSET__482d763c__"